import { render, staticRenderFns } from "./LegalPageLayout.vue?vue&type=template&id=6da3fefe&scoped=true&"
import script from "./LegalPageLayout.vue?vue&type=script&lang=ts&"
export * from "./LegalPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./LegalPageLayout.vue?vue&type=style&index=0&id=6da3fefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3fefe",
  null
  
)

export default component.exports